module.exports = __webpack_public_path__ + "media/images/challenges/talent-league-iv/white-bullet-2cb57db12ccbd67214c081aee247307b.svg";